import { ServiceAlertApiClient } from '@/libs/ServiceAlertApiClient';
import { paramTypeEnum } from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { ServiceAlertTypeEnum } from '@/libs/ServiceAlert';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';

export interface GetAlertMessageResp extends GeneralResp {
    requestToken: string | null;
    isShowAlertMessage: boolean;
    alertHash: string | null;
    alertType: ServiceAlertTypeEnum;
    alertTitle: string | null;
    alertMessage: string | null;
    idleTimeoutHintMinutes: number;
}
/**
 * @todo 取得停登訊息
 */
const GetAlertMessage = (): Promise<GetAlertMessageResp> => {
    const url = RouteUrlList.API_ServiceAlert.path;
    const config = {
        params: { showOverlay: paramTypeEnum.false, getServiceAlert: paramTypeEnum.true }
    };
    return ServiceAlertApiClient.post(url, {}, config).then((res: AxiosResponse<GetAlertMessageResp>) => {
        return res.data;
    });
};

export default GetAlertMessage;
